(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rcl-showroom"] && !Shopify.designMode) return;
  try {
    
(function(){
 function initShowroomScroll(){
  var target=document.getElementById('rcl-showroom');
  if(!target||target.dataset.rclScrollReady)return;
  target.dataset.rclScrollReady='true';
  var header=document.getElementById('header-outer');
  var nav=document.getElementById('nav-outer');
  function visibleHeaderBottom(){
    var bottom=0;
    var mobile=window.matchMedia('(max-width:1000px)').matches;
    var candidates=mobile?[document.getElementById('header'),header]:[header,nav];
    candidates.forEach(function(element){
      if(!element)return;
      var rect=element.getBoundingClientRect();
      var style=getComputedStyle(element);
      if(style.display==='none'||style.visibility==='hidden'||rect.height===0)return;
      var pinned=false;
      for(var parent=element;parent&&parent!==document.body;parent=parent.parentElement){
        var position=getComputedStyle(parent).position;
        if(position==='fixed'||position==='sticky'||parent.classList.contains('fixed')){pinned=true;break;}
      }
      if(pinned&&rect.top<window.innerHeight/2&&rect.bottom>0&&rect.bottom<window.innerHeight/2){
        bottom=Math.max(bottom,rect.bottom);
      }
    });
    return bottom+(mobile&&bottom>0?4:0);
  }
  function updateOffset(){
    target.style.setProperty('--rcl-showroom-header-offset',visibleHeaderBottom()+'px');
  }
  var frame=0;
  var activeUntil=0;
  var correctionTimer=0;
  var scrollStyle=document.documentElement.style;
  var previousScrollBehavior=scrollStyle.scrollBehavior;
  function restoreScrollBehavior(){scrollStyle.scrollBehavior=previousScrollBehavior;}
  function destination(){
    return Math.max(0,window.scrollY+target.getBoundingClientRect().top-visibleHeaderBottom());
  }
  function go(){
    cancelAnimationFrame(frame);
    clearTimeout(correctionTimer);
    previousScrollBehavior=frame?previousScrollBehavior:scrollStyle.scrollBehavior;
    scrollStyle.scrollBehavior='auto';
    var startY=window.scrollY;
    var started=performance.now();
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var duration=reduced?0:Math.min(1100,Math.max(550,Math.abs(destination()-startY)*0.35));
    activeUntil=Date.now()+5000;
    function step(now){
      var progress=duration?Math.min(1,(now-started)/duration):1;
      var eased=1-Math.pow(1-progress,3);
      window.scrollTo(0,startY+(destination()-startY)*eased);
      if(progress<1)frame=requestAnimationFrame(step);
      else {
        frame=0;restoreScrollBehavior();
        correctionTimer=setTimeout(function(){
          if(Date.now()<activeUntil&&Math.abs(destination()-window.scrollY)>2){
            scrollStyle.scrollBehavior='auto';window.scrollTo(0,destination());restoreScrollBehavior();
          }
        },300);
      }
    }
    frame=requestAnimationFrame(step);
  }
  function cancel(){
    cancelAnimationFrame(frame);frame=0;activeUntil=0;clearTimeout(correctionTimer);restoreScrollBehavior();
  }
  ['wheel','touchstart','pointerdown','keydown'].forEach(function(name){window.addEventListener(name,cancel,{passive:true});});
  window.addEventListener('click',function(event){
    var link=event.target instanceof Element?event.target.closest('a[href]'):null;
    if(!link||(typeof event.button==='number'&&event.button!==0)||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||link.target==='_blank')return;
    var url=new URL(link.href,location.href);
    if(url.origin!==location.origin||url.pathname!==location.pathname||url.hash!=='#rcl-showroom')return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(location.hash!=='#rcl-showroom')history.pushState(null,'','#rcl-showroom');
    go();
  },true);
  window.addEventListener('hashchange',function(){if(location.hash==='#rcl-showroom')go();});
  window.addEventListener('load',function(){if(location.hash==='#rcl-showroom')go();},{once:true});
  if(window.ResizeObserver){
    new ResizeObserver(function(){
      updateOffset();
      if(frame||Date.now()>activeUntil)return;
      clearTimeout(correctionTimer);
      correctionTimer=setTimeout(function(){if(Date.now()<activeUntil&&Math.abs(destination()-window.scrollY)>2)go();},150);
    }).observe(document.body);
  }
  updateOffset();
  if(document.readyState==='complete'&&location.hash==='#rcl-showroom')go();

 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initShowroomScroll,{once:true});
 else initShowroomScroll();
 document.addEventListener('shopify:section:load',initShowroomScroll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcl-stock-groups"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const list = root.querySelector('[data-stock-group-list]');
    const back = root.querySelector('[data-stock-back]');
    const selectedType = () => {
      if (!location.hash.startsWith('#category=')) return null;
      try { return decodeURIComponent(location.hash.slice(10)); } catch { return null; }
    };
    const navigate = () => {
      const selected = selectedType();
      back.hidden = selected === null;
      [...list.children].forEach(group => {
        group.hidden = selected !== null && group.dataset.type !== selected;
        group.open = selected !== null && group.dataset.type === selected;
      });
    };
    window.addEventListener('hashchange', navigate);
    window.addEventListener('popstate', navigate);
    const recount = () => {
      list.querySelectorAll('.rcl-stock-group').forEach(group => {
        group.querySelector('[data-group-count]').textContent = group.querySelectorAll('[data-product-id]').length;
      });
      [...list.children].sort((a,b) => a.dataset.type.localeCompare(b.dataset.type)).forEach(group => list.append(group));
    };
    const merge = incoming => {
      incoming.querySelectorAll('.rcl-stock-group').forEach(group => {
        const existing = [...list.children].find(g => g.dataset.type === group.dataset.type);
        if (!existing) { list.append(group); return; }
        const grid = existing.querySelector('.rcl-stock-group-grid');
        group.querySelectorAll('[data-product-id]').forEach(card => {
          if (![...grid.children].some(c => c.dataset.productId === card.dataset.productId)) grid.append(card);
        });
      });
      recount();
      navigate();
    };
    let busy = false;
    const load = async () => {
      if (busy) return;
      busy = true;
      let next = root.querySelector('[data-stock-next]');
      try {
        while (next) {
          const url = new URL(next.href);
          url.searchParams.set('section_id', root.dataset.section);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Unable to load');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = doc.querySelector('[data-stock-groups]');
          if (!incoming) throw new Error('Missing product groups');
          merge(incoming);
          const following = incoming.querySelector('[data-stock-next]');
          if (following) { next.href = following.href; } else { next.remove(); next = null; }
        }
      } catch (error) {
        if (next) next.hidden = false;
      } finally { busy = false; }
    };
    root.addEventListener('click', event => {
      const summary = event.target.closest('.rcl-stock-group > summary');
      if (summary) {
        event.preventDefault();
        location.hash = 'category=' + encodeURIComponent(summary.parentElement.dataset.type);
        navigate();
        back.focus();
      }
      if (event.target.closest('[data-stock-back]')) {
        event.preventDefault();
        history.pushState(null, '', location.pathname + location.search);
        navigate();
        list.querySelector('summary')?.focus();
      }
      if (event.target.closest('[data-stock-next]')) { event.preventDefault(); load(); }
    });
    recount();
    navigate();
    load();
  };
  document.querySelectorAll('[data-stock-groups]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-stock-groups]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcl-today-hours"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(customElements.get('rcl-today-hours'))return;
  class RclTodayHours extends HTMLElement{
    connectedCallback(){
      this.updateHours();
      this.timer=setInterval(()=>this.updateHours(),60000);
      this.onVisible=()=>this.updateHours();
      document.addEventListener('visibilitychange',this.onVisible);
    }
    disconnectedCallback(){
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange',this.onVisible);
    }
    updateHours(){
      var day=new Intl.DateTimeFormat('en-US',{timeZone:'America/Chicago',weekday:'short'}).format(new Date());
      var hours=day==='Sun'?this.dataset.sunday:day==='Sat'?this.dataset.saturday:this.dataset.weekdays;
      var target=this.querySelector('[data-today-hours]');
      if(target&&target.textContent!==hours)target.textContent=hours;
    }
  }
  customElements.define('rcl-today-hours',RclTodayHours);
})();

  } catch(e) { console.error(e); }
})();
})();
